import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Typography, Box, useMediaQuery } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { Grid } from "@material-ui/core";
import invitesActions from "./actions";

const useStyles = makeStyles((theme) => ({
  card: {
    background: "#C6CCDD 0% 0% no-repeat padding-box",
    borderRadius: 8,
    opacity: 1,
  },
}));

const InvitesOverview = () => {
  const { breakDown } = useSelector((state) => state.invites);
  const classes = useStyles();
  const { loadInviteBreakDown } = invitesActions();
  useEffect(() => {
    loadInviteBreakDown();
  }, [loadInviteBreakDown]);
  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));

  return (
    <>
      <Box my={2}>
        <Grid
          container
          justify={matches ? "flex-start" : "center"}
          alignItems="center"
        >
          <Typography variant="h5">Invites</Typography>
        </Grid>
      </Box>
      <Grid container justify="flex-start">
        {[{ h: "Invites", c: breakDown["count"] }].map((value) => (
          <Grid item xs={4} md={2} key={value["h"]}>
            <Box
              m={1}
              p={matches ? 2 : 1}
              height={matches ? "auto" : "50px"}
              className={classes.card}
            >
              <Typography
                variant={matches ? "subtitle2" : "caption"}
                color="secondary"
                gutterBottom
              >
                {value.h}
              </Typography>
              <Typography variant={matches ? "h5" : "subtitle2"} gutterBottom>
                {value.c}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default InvitesOverview;
